import { Box, Accordion, Group, Text, Stack, Paper } from '@mantine/core';
import { Loan } from '@/types/nsldsTypes';
import { useLoans } from '@/hooks/use-loans';
import { formatCurrency } from '@/utils/formatters';

export function LoansListPanel() {
  const {
    filteredLoans,
    loansByStatus,
    totalsByStatus,
    selectedLoan,
    accordionValue,
    setAccordionValue,
    setSelectedLoan,
    setModalOpen,
    isMobile,
  } = useLoans();

  const handleSelectLoan = (loan: Loan) => {
    setSelectedLoan(loan);
    if (isMobile) {
      setModalOpen(true);
    }
  };

  return (
    <Box
      style={{
        height: '100%',
        overflowY: 'auto',
        width: '100%',
        scrollbarWidth: 'thin',
        scrollbarGutter: 'stable',
        flex: 1,
      }}
    >
      <Accordion
        value={accordionValue}
        onChange={setAccordionValue}
        w="100%"
        chevronPosition="left"
      >
        {Object.entries(loansByStatus).map(([status, loans]) => (
          <Accordion.Item key={status} value={status}>
            <Accordion.Control>
              <Group justify="space-between" wrap="nowrap" w="100%">
                <Text fw={700} truncate="end" style={{ flex: 1, minWidth: 0 }}>
                  {status}
                </Text>
                <Text fw={500}>{formatCurrency(totalsByStatus[status])}</Text>
              </Group>
            </Accordion.Control>
            <Accordion.Panel>
              <Stack gap="xs">
                {loans.map((loan) => {
                  const loanType = loan['Loan Type Group'];
                  const totalOutstanding = loan['Total Outstanding'] || 0;
                  const schoolName = loan['Loan Attending School Name'];
                  const contactName = loan['Loan Contact Name'];
                  const isSelected =
                    selectedLoan && selectedLoan['Loan Award ID'] === loan['Loan Award ID'];

                  return (
                    <Paper
                      key={loan['Loan Award ID']}
                      p="sm"
                      shadow="none"
                      bg={
                        !isMobile && isSelected ? 'var(--mantine-color-primary-light)' : undefined
                      }
                      style={{
                        cursor: 'pointer',
                        position: 'relative',
                        overflow: 'hidden',
                      }}
                      onClick={() => {
                        handleSelectLoan(loan);
                      }}
                    >
                      {/* Selection indicator */}
                      <Box
                        style={{
                          position: 'absolute',
                          left: 0,
                          top: 0,
                          bottom: 0,
                          width: '3px',
                          backgroundColor:
                            !isMobile && isSelected
                              ? 'var(--mantine-color-primary)'
                              : 'transparent',
                        }}
                      />
                      <Stack w="100%" gap={2}>
                        <Group justify="space-between" wrap="nowrap" style={{ width: '100%' }}>
                          {/* Allow loan type text to shrink and truncate */}
                          <Text size="sm" truncate="end" style={{ flex: 1, minWidth: 0 }} fw={700}>
                            {loanType}
                          </Text>
                          <Text size="sm">{formatCurrency(totalOutstanding)}</Text>
                        </Group>
                        <Text size="sm" truncate="end" style={{ flex: 1, minWidth: 0 }}>
                          {contactName ? contactName + ', ' : ''} {schoolName}
                        </Text>
                      </Stack>
                    </Paper>
                  );
                })}
              </Stack>
            </Accordion.Panel>
          </Accordion.Item>
        ))}
      </Accordion>

      {filteredLoans.length === 0 && (
        <Text ta="center" py="md" c="dimmed">
          No loans match the current filter
        </Text>
      )}
    </Box>
  );
}
